export const apiEndPoint = `https://andix678werd123-dev6420.azurewebsites.net/`;
// export const apiEndPoint = `http://10.0.0.34:8000/`;
// export const apiEndPoint = `http://127.0.0.1:8000/`;
// export const apiEndPoint = 'http://10.17.98.119:8000/';
export const mainApiEndPoint = 'http://localhost/8000';
export const cgeApiEndPoint = 'http://localhost/8001';